// extracted by mini-css-extract-plugin
export default {"container":"icon_container__idEsi","truncate-table":"icon_truncate-table__8fyST","table-text-faded":"icon_table-text-faded__CvYj9","icon":"icon_icon__wT4Vw","customIcon":"icon_customIcon__FFxZl"};
    if(module.hot) {
      // 1792500644375
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  